import getQueryParams from "./getQueryParams";

interface CustomSizeQuery {
    customTireSize?: string[];
    customWheelSize?: string[];
  }

export default function getCustomSizeQuery(): CustomSizeQuery {
  const customTireSize = getQueryParams("customTireSize");
  const customWheelSize = getQueryParams("customWheelSize");

  if (customTireSize?.length > 0 || customWheelSize?.length > 0) {
    return {
      customTireSize,
      customWheelSize,
    };
  }
  return {};
}
